/**
 * Get the minimum and maximum numbers from an array of numbers. This function
 * works for large arrays with tens of thousands of elements. Math.min and
 * Math.max has a limit depending on the environment.
 * https://stackoverflow.com/a/30834687/14138325
 * @param arr
 * @returns [min, max]
 */
export function getMinMax(arr: number[]): [number, number] {
  if (arr.length === 0) {
    throw new Error("Array is empty");
  }
  let min = arr[0];
  let max = arr[0];
  let i = arr.length;

  while (i--) {
    min = arr[i] < min ? arr[i] : min;
    max = arr[i] > max ? arr[i] : max;
  }
  return [min, max];
}

export function last<T>(array: Array<T>): T {
  return array[array.length - 1];
}
